import { render, staticRenderFns } from "./StyledTextEditor.vue?vue&type=template&id=6e55cb36&scoped=true&"
import script from "./StyledTextEditor.vue?vue&type=script&lang=js&"
export * from "./StyledTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./StyledTextEditor.vue?vue&type=style&index=0&id=6e55cb36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e55cb36",
  null
  
)

export default component.exports